export default __webpack_public_path__ + "static/media/soundcloud.3a98bb21.svg";